module.exports = __webpack_public_path__ + "829d8c6df62fbed914a93df1d496c998.svg";